var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.submitting
        ? _c("KCircularLoader")
        : _vm.mastered
        ? _c("QuizReport", {
            attrs: {
              userId: _vm.userId,
              userName: _vm.userFullName,
              content: _vm.content,
            },
            on: { repeat: _vm.repeat },
          })
        : _c(
            "KGrid",
            { attrs: { gridStyle: _vm.gridStyle } },
            [
              _vm.windowIsLarge
                ? _c(
                    "KGridItem",
                    {
                      ref: "questionListWrapper",
                      staticClass: "column-pane",
                      attrs: { layout12: { span: 4 } },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "column-contents-wrapper" },
                        [
                          _c(
                            "KPageContainer",
                            [
                              _c("AnswerHistory", {
                                attrs: {
                                  pastattempts: _vm.pastattempts,
                                  questionNumber: _vm.questionNumber,
                                  wrapperComponentRefs: _vm.$refs,
                                  questions: _vm.itemIdArray,
                                  currentQuestionAnswered:
                                    _vm.currentQuestionAnswered,
                                },
                                on: { goToQuestion: _vm.goToQuestion },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "KGridItem",
                {
                  staticClass: "column-pane",
                  attrs: { layout12: { span: 8 } },
                },
                [
                  _c(
                    "div",
                    {
                      class: { "column-contents-wrapper": !_vm.windowIsSmall },
                    },
                    [
                      _c(
                        "KPageContainer",
                        [
                          _c("h1", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$tr("question", {
                                    num: _vm.questionNumber + 1,
                                    total: _vm.questionsTotal,
                                  })
                                ) +
                                "\n          "
                            ),
                          ]),
                          _vm.itemId
                            ? _c("ContentViewer", {
                                ref: "contentViewer",
                                attrs: {
                                  lang: _vm.content.lang,
                                  files: _vm.content.files,
                                  extraFields: _vm.extraFields,
                                  itemId: _vm.itemId,
                                  assessment: true,
                                  allowHints: false,
                                  answerState: _vm.currentAttempt.answer,
                                  progress: _vm.progress,
                                  userId: _vm.userId,
                                  userFullName: _vm.userFullName,
                                  timeSpent: _vm.timeSpent,
                                },
                                on: {
                                  interaction: _vm.interactionHandler,
                                  updateProgress: _vm.updateProgress,
                                  updateContentState: _vm.updateContentState,
                                  error: (err) => _vm.$emit("error", err),
                                },
                              })
                            : _c(
                                "UiAlert",
                                {
                                  attrs: { dismissible: false, type: "error" },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$tr("noItemId")) +
                                      "\n          "
                                  ),
                                ]
                              ),
                        ],
                        1
                      ),
                      _c(
                        "BottomAppBar",
                        {
                          attrs: {
                            dir: _vm.bottomBarLayoutDirection,
                            maxWidth: null,
                          },
                        },
                        [
                          _c(
                            _vm.windowIsSmall ? "div" : "KButtonGroup",
                            { tag: "component" },
                            [
                              _c(
                                "KButton",
                                {
                                  attrs: {
                                    disabled:
                                      _vm.questionNumber ===
                                      _vm.questionsTotal - 1,
                                    primary: true,
                                    dir: _vm.layoutDirReset,
                                    "aria-label": _vm.$tr("nextQuestion"),
                                    appearanceOverrides:
                                      _vm.navigationButtonStyle,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goToQuestion(
                                        _vm.questionNumber + 1
                                      )
                                    },
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "iconAfter",
                                      fn: function () {
                                        return [
                                          _c("KIcon", {
                                            style: _vm.navigationIconStyleNext,
                                            attrs: {
                                              icon: "forward",
                                              color: "white",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                },
                                [
                                  _vm.displayNavigationButtonLabel
                                    ? _c("span", [
                                        _vm._v(_vm._s(_vm.$tr("nextQuestion"))),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                              _c(
                                "KButton",
                                {
                                  class: { "left-align": _vm.windowIsSmall },
                                  attrs: {
                                    disabled: _vm.questionNumber === 0,
                                    primary: true,
                                    dir: _vm.layoutDirReset,
                                    appearanceOverrides:
                                      _vm.navigationButtonStyle,
                                    "aria-label": _vm.$tr("previousQuestion"),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goToQuestion(
                                        _vm.questionNumber - 1
                                      )
                                    },
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "icon",
                                      fn: function () {
                                        return [
                                          _c("KIcon", {
                                            style:
                                              _vm.navigationIconStylePrevious,
                                            attrs: {
                                              icon: "back",
                                              color: "white",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                },
                                [
                                  _vm.displayNavigationButtonLabel
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$tr("previousQuestion"))
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm.windowIsLarge
                            ? _c(
                                "div",
                                {
                                  staticClass: "left-align",
                                  attrs: { dir: _vm.layoutDirReset },
                                },
                                [
                                  _c("div", { staticClass: "answered" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.answeredText) +
                                        "\n            "
                                    ),
                                  ]),
                                  _c("KButton", {
                                    attrs: {
                                      text: _vm.isSurvey
                                        ? _vm.$tr("submitSurvey")
                                        : _vm.$tr("submitExam"),
                                      primary: false,
                                      appearance: "flat-button",
                                    },
                                    on: { click: _vm.toggleModal },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      !_vm.windowIsLarge
                        ? _c(
                            "KPageContainer",
                            { staticStyle: { "margin-bottom": "45px" } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "bottom-block",
                                  class: {
                                    "window-is-small": _vm.windowIsSmall,
                                  },
                                },
                                [
                                  _c("div", { staticClass: "answered" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.answeredText) +
                                        "\n            "
                                    ),
                                  ]),
                                  _c("KButton", {
                                    attrs: {
                                      text: _vm.isSurvey
                                        ? _vm.$tr("submitSurvey")
                                        : _vm.$tr("submitExam"),
                                      primary: false,
                                      appearance: "flat-button",
                                    },
                                    on: { click: _vm.toggleModal },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
      _vm.submitModalOpen
        ? _c(
            "KModal",
            {
              attrs: {
                title: _vm.isSurvey
                  ? _vm.$tr("submitSurvey")
                  : _vm.$tr("submitExam"),
                submitText: _vm.isSurvey
                  ? _vm.$tr("submitSurvey")
                  : _vm.$tr("submitExam"),
                cancelText: _vm.coreString("goBackAction"),
              },
              on: { submit: _vm.finishExam, cancel: _vm.toggleModal },
            },
            [
              _c("p", [_vm._v(_vm._s(_vm.$tr("areYouSure")))]),
              _vm.questionsUnanswered
                ? _c("p", [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.$tr("unanswered", {
                            numLeft: _vm.questionsUnanswered,
                          })
                        ) +
                        "\n    "
                    ),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }